import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    let initialUser = null;
    
    if (savedUser) {
      try {
        initialUser = JSON.parse(savedUser);
        setUser(initialUser);
      } catch (e) {
        console.error('Failed to parse saved user');
      }
    }
    
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await api.get('/auth/me');
      if (response.data.success) {
        const employee = response.data.data.employee;
        const mergedUser = initialUser ? { ...initialUser, ...employee } : employee;
        setUser(mergedUser);
        localStorage.setItem('user', JSON.stringify(mergedUser));
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } catch (error) {
      if (initialUser) {
        setUser(initialUser);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.success) {
      localStorage.setItem('token', response.data.data.token);
      const employee = response.data.data.employee;
      const savedUser = localStorage.getItem('user');
      let mergedUser = employee;
      
      if (savedUser) {
        try {
          const existingUser = JSON.parse(savedUser);
          mergedUser = { ...existingUser, ...employee };
        } catch (e) {
          // ignore
        }
      }
      
      setUser(mergedUser);
      localStorage.setItem('user', JSON.stringify(mergedUser));
      return { success: true };
    }
    return { success: false, message: response.data.message };
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const updateUser = (updatedUser) => {
    const newUser = { ...user, ...updatedUser };
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
